import { useContext } from 'react';
import { PacksContext } from './PacksProvider.jsx';

export function usePacks() {
  const ctx = useContext(PacksContext);
  if (!ctx) {
    throw new Error('usePacks must be used within <PacksProvider>.');
  }
  return ctx;
}
